/**
 * Standard paths for event assets. Use these so all events follow the same layout.
 * Convention: public/asset/images/events/<platform>/<slug>/<filename>
 */

const EVENT_ASSET_BASE = '/asset/images/events';
const EVENT_DOCUMENTS_BASE = '/asset/documents/events';

/**
 * Relative asset directory for an event (no leading slash).
 * Example: 'cortex/conference-2026'
 */
export const getEventAssetDir = (platform, slug) =>
  `${platform}/${slug}`;

/**
 * Full URL path for an event's poster image (for use in config or components).
 * Example: '/asset/images/events/cortex/conference-2026/poster.jpg'
 * File on disk: public/asset/images/events/cortex/conference-2026/poster.jpg
 */
export const getEventPosterPath = (platform, slug, ext = 'jpg') =>
  `${EVENT_ASSET_BASE}/${platform}/${slug}/poster.${ext}`;

/**
 * Full URL path for any image under an event's asset folder.
 * Example: getEventImagePath('cortex', 'conference-2026', 'hero.webp')
 * → '/asset/images/events/cortex/conference-2026/hero.webp'
 */
export const getEventImagePath = (platform, slug, filename) =>
  `${EVENT_ASSET_BASE}/${platform}/${slug}/${filename}`;

/**
 * Full URL path for a file under public/asset/documents/events/<platform>/<slug>/.
 * Example: getEventDocumentPath('cortex', 'workshop-2026', 'slides.pdf')
 */
export const getEventDocumentPath = (platform, slug, filename) =>
  `${EVENT_DOCUMENTS_BASE}/${platform}/${slug}/${filename}`;

/** Base path for event assets (e.g. for listing or docs) */
export { EVENT_ASSET_BASE, EVENT_DOCUMENTS_BASE };
